import EN from "assets/images/flags/global.svg";
import ES from "assets/images/flags/es.svg";
import EN_CA from "assets/images/flags/ca.svg";
import EN_GB from "assets/images/flags/gb.svg";

const langs = {
  EN,
  ES,
  EN_CA,
  EN_GB,
};

export default langs;
